export default "__VITE_ASSET__CyQy3Xcw__"